import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment';
import React from 'react';
import Balancer from 'react-wrap-balancer';
import BackButton from '../molecules/BackButton';

interface ResourceHeroProps {
  title: string;
  backButton: {
    label: string;
    url: string;
  };
  date: string;
  tags?: string[];
  image?: any;
  youTubeId?: string;
}

const ResourceHero: React.FC<ResourceHeroProps> = ({
  title,
  backButton,
  date,
  tags,
  image,
  youTubeId,
}) => (
  <section className="container pt-10 mb-10 lg:pt-20 lg:mb-20">
    <div className="mb-4 text-center">
      <BackButton {...backButton} />
    </div>
    <h1 className="max-w-2xl mx-auto mb-4 leading-tight text-center u-h1">
      <Balancer>{title}</Balancer>
    </h1>
    <div className="flex flex-col items-center justify-center space-y-4 text-sm text-center md:space-y-0 md:space-x-2 md:flex-row text-slate-500 lg:text-base">
      <div>{moment.utc(date).format('MMMM DD, YYYY')}</div>

      {tags && (
        <>
          <div className="hidden md:block">&middot;</div>
          <div className="flex items-center space-x-2">
            {tags.map((tag) => (
              <span
                key={tag}
                className="inline-block px-2 py-1 font-semibold leading-none uppercase rounded-sm bg-slate-200 text-slate-500 text-xxs"
              >
                {tag}
              </span>
            ))}
          </div>
        </>
      )}
    </div>

    {image && (
      <div className="my-10 -mx-4 lg:my-20 md:mx-0">
        <GatsbyImage
          image={getImage(image)}
          alt={image.title}
          imgClassName="w-full h-auto"
          className="overflow-hidden sm:rounded md:rounded-lg"
        />
      </div>
    )}

    {youTubeId && (
      <div className="my-10 -mx-4 lg:my-20 md:mx-0 aspect-w-16 aspect-h-9">
        <iframe
          src={`https://www.youtube.com/embed/${youTubeId}?rel=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    )}
  </section>
);

export default ResourceHero;
